import { Routes, Route } from 'react-router-dom';
import Locations from '../child_components/Locations';
import MobileVans from '../child_components/MobileVans';
import MobileWorkshop from '../child_components/MobileWorkshop';
import SoftwareUpdates from '../child_components/SoftwareUpdate';
import TransferList from '../child_components/TransferList';

function Inventory() {

    return(
        <div>
            <Routes>
                <Route path='/mobile_vans' element={ <MobileVans /> } />
                <Route path='/mobile_workshop/*' element={ <MobileWorkshop /> } />
                <Route path='/software_updates' element={ <SoftwareUpdates /> } />
                <Route path='/transfer_list' element={ <TransferList /> } />
                <Route path='/locations' element={ <Locations /> } />
            </Routes>
        </div>
    )
}

export default Inventory;